import { TextField, Autocomplete } from "@mui/material";
import { Controller } from "react-hook-form";
import paymentdashboardservice from "../../../services/paymentdashboardservice";
import { useState, useEffect } from "react";

function SelectCategory({ getValues, setValue, errors, control }) {
  const [categories, setCategories] = useState([]);

  const Init = async () => {
    let categories = await paymentdashboardservice.FetchCampaignCategories();
    categories = categories.map((obj) => ({
      value: obj.name,
      label: obj.name,
    }));
    setCategories(categories);
  };

  useEffect(() => {
    Init();
  }, []);

  return (
    <Controller
      name="category"
      control={control}
      defaultValue={[]}
      render={({ field }) => (
        <Autocomplete
          multiple
          disableCloseOnSelect
          id="category-dropdown"
          options={categories}
          getOptionLabel={(option) => option.label}
          sx={{ width: 350 }}
          value={
            categories.filter((cat) =>
              (getValues("category") || []).some(
                (selected) => selected?.value === cat.value
              )
            ) || []
          }
          onChange={(_, newValue) => {
            const selectedCategories = newValue.map((item) => ({
              value: item.value,
              label: item.label,
            }));
            setValue("category", selectedCategories, { shouldValidate: true });
          }}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          filterOptions={(options, state) => {
            const inputValue = state.inputValue.toLowerCase().trim();
            return options.filter((option) => {
              const notSelected = !(getValues("category") || []).some(
                (selected) => selected?.value === option.value
              );
              const matchesSearch = option.label.toLowerCase().includes(inputValue);
              return notSelected && matchesSearch;
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!errors.category}
              helperText={errors.category?.message}
              label="Category*"
            />
          )}
        />
      )}
    />
  );
}

export default SelectCategory;
